import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export const VNZ_ACCESS_TOKEN_KEY = "VNZ_access_token"
export const VNZ_ACCESS_TOKEN_VALIDITY_IN_SECONDS_KEY =
  "VNZ_access_token_validity_in_seconds"
export const VNZ_REFRESH_TOKEN_KEY = "VNZ_refresh_token"
export const VNZ_REFRESH_TOKEN_DATE_KEY = "VNZ_refresh_token_date"

export interface VNZAuthState {
  // access token
  accessToken: string
  isAuthenticated: boolean
  isAuthenticating: boolean
  hasAuthenticationError: boolean
  authenticationError: string
  // refresh token
  refreshToken: string
  isRefreshingToken: boolean
  lastRefreshDate: string
  tokenValidityInSeconds: number
  hasRefreshTokenError: boolean
  refreshTokenError: string
}

const initialState: VNZAuthState = {
  accessToken: "",
  isAuthenticated: false,
  isAuthenticating: false,
  hasAuthenticationError: false,
  authenticationError: "",

  refreshToken: "",
  isRefreshingToken: false,
  lastRefreshDate: "",
  tokenValidityInSeconds: 0,
  hasRefreshTokenError: false,
  refreshTokenError: "",
}

export interface SetIsAuthenticatingPayload {
  isAuthenticating: boolean
}

export interface SetIsAuthenticatedPayload {
  accessToken: string
  refreshToken: string
  lastRefreshDate: string
  tokenValidityInSeconds: number
}

export interface SetAuthenticationErrorPayload {
  authenticationError: string
}

export const VNZAuth = createSlice({
  name: "VNZAuth",
  initialState,
  reducers: {
    setIsAuthenticating(
      state: VNZAuthState,
      action: PayloadAction<SetIsAuthenticatingPayload>
    ) {
      const { isAuthenticating } = action.payload
      state.isAuthenticating = isAuthenticating
      state.isAuthenticated = false
      state.hasAuthenticationError = false
      state.authenticationError = ""
    },
    setIsAuthenticated(
      state: VNZAuthState,
      action: PayloadAction<SetIsAuthenticatedPayload>
    ) {
      const {
        accessToken,
        refreshToken,
        lastRefreshDate,
        tokenValidityInSeconds,
      } = action.payload
      state.isAuthenticating = false
      state.isAuthenticated = true
      state.accessToken = accessToken
      state.refreshToken = refreshToken
      state.lastRefreshDate = lastRefreshDate
      state.tokenValidityInSeconds = tokenValidityInSeconds
      state.hasAuthenticationError = false
      state.authenticationError = ""
    },
    logout(state: VNZAuthState) {
      state.isAuthenticating = false
      state.isAuthenticated = false
      state.accessToken = ""
      state.refreshToken = ""
      state.lastRefreshDate = ""
      state.tokenValidityInSeconds = 0
      state.hasAuthenticationError = false
      state.authenticationError = ""
    },
    restoreAuthenticationStateFromLocalStorage(
      state: VNZAuthState,
      action: PayloadAction
    ) {},
    refreshAuthenticationToken(state: VNZAuthState, action: PayloadAction) {},
    setAuthenticationError(
      state: VNZAuthState,
      action: PayloadAction<SetAuthenticationErrorPayload>
    ) {
      const { authenticationError } = action.payload
      state.isAuthenticating = false
      state.isAuthenticated = false
      state.accessToken = ""
      state.hasAuthenticationError = true
      state.authenticationError = authenticationError
    },
  },
})
